import React, { Component } from 'react'

// lib
import { Col } from 'antd'
import { FaList } from 'react-icons/fa'

// sub component
import FileIconComponent from './fileIcon'

// redux
import { connect } from 'react-redux'
import mediaActions from '../../redux/component_select_media/actions'

// icon
import { FaDownload, FaEdit, FaTrash } from 'react-icons/fa'

import { Menu, Dropdown, Tooltip } from 'antd'

class MediaComponent extends Component {

    _handleSelect = () => {
        const { media } = this.props
        this.props.updateSelectMediaState(media.media_id, !media.isSelect)
    }

    _handleUpdateCurentMedia = () => {
        const { media } = this.props
        this.props.updateCurrentMedia(media)
        this.props.showModalCurrentMediaInfo()
        
    }

    handleClick = ({ key }) => {
        const { media } = this.props

        switch (key) {
            case 'Download':
                window.open(media.url, '_blank')
                break

            case 'Edit':
                this._handleUpdateCurentMedia()
                break

            case 'Delete':
                this.props.updateCurrentMedia(media)
                this.props.showModalConfirmDeleteMedia()
                break

            default:
                return
        }
    }

    renderMenu = () => {
        return (
            <Menu onClick={this.handleClick}>
                <Menu.Item key="Download">
                    <FaDownload style={{ marginRight: 5, color: '#9999ff' }} />
                    Download
                </Menu.Item>
                <Menu.Item key="Edit">
                    <FaEdit style={{ marginRight: 5, color: '#66ccff' }} />
                    Sửa
                </Menu.Item>
                <Menu.Item key="Delete">
                    <FaTrash style={{ marginRight: 5, color: '#ff8080' }} />
                    Xoá
                </Menu.Item>
            </Menu>
        )
    }

    render() {
        const { media } = this.props
        const { isSelect } = media

        const bgColor = isSelect ? "lightgreen" : "white"

        return (
            <Col className="MediaItem" md={6} lg={6} xs={8} xl={4}>
                <div
                    className="MediaComponent"
                    style={{ userSelect: 'none', backgroundColor: bgColor }}
                >
                    <Tooltip title={media.name}>
                        <Dropdown
                            overlay={this.renderMenu()}
                            trigger={['click']}
                            className="DropdownMenu"
                        >
                            <div onClick={() => { }}>
                                <FaList className="ActionIcon" />
                            </div>
                        </Dropdown>

                        <div
                            onClick={() => this._handleSelect()}
                        >

                            <FileIconComponent name={media.name} />
                            <div className="Title">{media.name}</div>
                        </div>
                    </Tooltip>
                </div>
            </Col>
        )
    }
}

const mapStateToProps = state => {
    return {}
}

const mapDispatchToProps = dispatch => {
    return {
        showModalConfirmDeleteMedia: () => {
            dispatch(mediaActions.action.showModalConfirmDeleteMedia())
        },
        showModalCurrentMediaInfo: () => {
            dispatch(mediaActions.action.showModalCurrentMediaInfo())
        },
        updateCurrentMedia: media => {
            dispatch(mediaActions.action.updateCurrentMedia(media))
        },
        updateSelectMediaState: (mid, selectState) => {
            dispatch(mediaActions.action.updateSelectMediaState(mid, selectState))
        }
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MediaComponent)
